import { Popover, Avatar, List, Button, Typography, Divider, message, Modal } from 'antd';
import {
    MobileOutlined,
    UserDeleteOutlined,
    LogoutOutlined,
    EditOutlined,
    WechatWorkOutlined,
    ExclamationCircleFilled,
} from '@ant-design/icons';
import { useState } from 'react';

import { logoutApi } from '../../api/modules/login'
import { useNavigate } from 'react-router-dom'
import phone from '@/assets/icon/AI／icon／phone.png'
import wechat from '@/assets/images/wechat.png'
import UpdatePhoneModal from './UpdatePhoneModal';
import UpdateUsernameModal from './UpdateUsernameModal';
import TipsModalComponent from '@/pages/components/TipsModal'
import { useUserActions } from '@/hooks/useUser';
const { Text } = Typography;

const UserProfilePanel = ({ }: any) => {
    const { userInfo, setUserInfo } = useUserActions();
    const navigate = useNavigate()

    const hasPhone = !!userInfo?.phone;
    const [isUpdatePhoneOpen, setIsUpdatePhoneOpen] = useState(false);
    const [isUsernameModalOpen, setIsUsernameModalOpen] = useState(false);
    const [isWeChatModalOpen, setIsWeChatModalOpen] = useState(false)
    const [currentUsername, setCurrentUsername] = useState('账户名');

    const loginOut = () => {
        logoutApi()
        localStorage.removeItem(import.meta.env.VITE_TOKEN_KEY)
        setUserInfo({
            name: ''
            ,
            phone: '',
            avatar: ''
        });
        navigate('/login')
    }
    const showDeleteConfirm = (onConfirm) => {
        Modal.confirm({
            title: '确定注销账号吗？',
            icon: <ExclamationCircleFilled style={{ color: '#ff4d4f' }} />,
            content: '注销账号后，相关数据将会永久删除，不可恢复，是否确认注销？',
            okText: '确定',
            okType: 'primary',
            cancelText: '取消',
            centered: true, // 居中显示
            onOk() {
                // 在这里调用后端注销接口
                return new Promise((resolve, reject) => {
                    console.log('正在执行注销逻辑...');
                    setTimeout(resolve, 1000); // 模拟请求
                }).then(() => {
                    message.success('账号已成功注销');
                    onConfirm?.();
                }).catch(() => {
                    message.error('注销失败，请稍后重试');
                });
            },
            onCancel() {
                console.log('取消注销');
            },
        });
    };
    return (
        < div style={{ width: 300 }}>
            <UpdateUsernameModal
                visible={isUsernameModalOpen}
                initialValue={currentUsername}
                onCancel={() => setIsUsernameModalOpen(false)}
                onSuccess={(newName: string) => {
                    setCurrentUsername(newName);
                    setIsUsernameModalOpen(false);
                }}
            />
            <UpdatePhoneModal
                visible={isUpdatePhoneOpen}
                currentPhone={userInfo.phone}
                onCancel={() => setIsUpdatePhoneOpen(false)}
                onSuccess={() => {
                    setIsUpdatePhoneOpen(false);
                    // 这里可以重新拉取用户信息
                }}
            />
            <TipsModalComponent
                way="微信群"
                imageLink={wechat}
                isVisible={isWeChatModalOpen}
                setModalVisible={setIsWeChatModalOpen}
            />
            {/* 顶部个人信息区域 */}
            < div style={{ display: 'flex', alignItems: 'center', padding: '20px 16px', background: '#f0f5ff', borderRadius: '8px 8px 0 0' }}>
                <Avatar size={40} src={userInfo.avatar} style={{ backgroundColor: '#2f54eb' }}>
                    {userInfo.name?.[0]}
                </Avatar>
                <div style={{ marginLeft: 12, flex: 1 }}>
                    <Text strong style={{ fontSize: 16 }}>{userInfo.name}</Text>
                    {/* <EditOutlined style={{ marginLeft: 8, color: '#8c8c8c', cursor: 'pointer' }} onClick={() => setIsUsernameModalOpen(true)} /> */}
                </div>
            </div >
            < div style={{ padding: '16px 32px' }}>
                {/* 手机号行 */}
                < div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '16px 0' }}>
                    <div style={{ display: 'flex', alignItems: 'start' }}>
                        <img src={phone} alt="" style={{ width: 24, marginTop: 4, marginRight: 12 }} />

                        <div>
                            <div style={{ fontWeight: 500 }}>手机号</div>
                            <Text type="secondary">{hasPhone ? userInfo.phone : '未绑定手机号'}</Text>
                        </div>
                    </div>
                    {/* <Button onClick={() => setIsUpdatePhoneOpen(true)}>{hasPhone ? '更换手机' : '立即绑定'}</Button> */}

                </div >

                {/* <Divider style={{ margin: '8px 0px' }} /> */}

                {/* 注销账号行 */}
                {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '16px 0' }}>
                    <div style={{ display: 'flex', alignItems: 'start' }}>
                        <UserDeleteOutlined style={{ fontSize: 20, marginTop: 4, marginRight: 12 }} />
                        <div style={{ paddingRight: 8 }}>
                            <div style={{ fontWeight: 500 }}>注销账号</div>

                        </div>
                    </div>
                    <Button onClick={() => showDeleteConfirm(() => {
                        loginOut()
                    })}>注销账号</Button>
                </div> */}

                <Divider style={{ margin: '8px 0' }} />

                {/* 退出登录行 */}
                <div
                    style={{ display: 'flex', alignItems: 'center', padding: '12px 0', cursor: 'pointer', justifyContent: "space-between" }}

                >
                    <div onClick={loginOut}><LogoutOutlined style={{ fontSize: 18, marginRight: 12, color: '#ff4d4f', }} />
                        <span style={{ fontWeight: 500 }}>退出登录</span></div>
                    <div onClick={() => setIsWeChatModalOpen(true)}><WechatWorkOutlined style={{ fontSize: 18, marginRight: 12 }} />
                        <span style={{ fontWeight: 500 }}>联系我们</span></div>
                </div>
            </div>
        </div >)
}

export default UserProfilePanel